import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import ServiceDropboxSelector from '@/components/Ui/ServiceDropboxSelector'
import ServiceContentsScreenSelectorButton from '@/components/Ui/ServiceContentsScreenSelectorButton'
import ServiceDeliveryTypeSelectorButton from '@/components/Ui/ServiceDeliveryTypeSelectorButton'
import ServiceRssSelectorButton from '@/components/Ui/ServiceRssSelectorButton'
import VideochatSelectorButton from '@/components/Ui/VideoChatSelectorButton'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ContentsHeader',
  components: {
    FileSelectorButton,
    ServiceDropboxSelector,
    ServiceContentsScreenSelectorButton,
    ServiceDeliveryTypeSelectorButton,
    ServiceRssSelectorButton,
    VideochatSelectorButton
  },
  props: {
    index: Number
  },
  data () {
    return {
      inited: false,

      buttonCount: 0,

      // ファイルタイプの選択
      inpFileType1: '',
      inpFileType2: '',
      inpFileType3: '',
      inpFileType4: '',

      // input
      input: {
        logoFile: null,
        panelColor: null,
        panelTransparency: 0,
        btnSettings: [
          {
            btnName: null,
            iconFile: null,
            labelText: null,
            btnActionType: '',
            btnActionParameter: {
              screenCode: null,
              webUrl: null,
              localFile: null,
              dropBoxFile: {
                serviceDropboxUuid: null,
                fileType: '',
              },
              launchSpApp: null,
              dataUri: null,
              extraData: [
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
              ],
              mimeType: null,
              action: null,
            },
            badgeUseFlg: 0,
            badgeDisplayCondition: 0,
            badgeDisplayParameter: {
              deliveryTypes: [],
              serviceRssUUIDs: []
            }
          },
          {
            btnName: null,
            iconFile: null,
            labelText: null,
            btnActionType: '',
            btnActionParameter: {
              screenCode: null,
              webUrl: null,
              localFile: null,
              dropBoxFile: {
                serviceDropboxUuid: null,
                fileType: '',
              },
              launchSpApp: null,
              dataUri: null,
              extraData: [
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
              ],
              mimeType: null,
              action: null,
            },
            badgeUseFlg: 0,
            badgeDisplayCondition: 0,
            badgeDisplayParameter: {
              deliveryTypes: [],
              serviceRssUUIDs: []
            }
          },
          {
            btnName: null,
            iconFile: null,
            labelText: null,
            btnActionType: '',
            btnActionParameter: {
              screenCode: null,
              webUrl: null,
              localFile: null,
              dropBoxFile: {
                serviceDropboxUuid: null,
                fileType: '',
              },
              launchSpApp: null,
              dataUri: null,
              extraData: [
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
              ],
              mimeType: null,
              action: null,
            },
            badgeUseFlg: 0,
            badgeDisplayCondition: 0,
            badgeDisplayParameter: {
              deliveryTypes: [],
              serviceRssUUIDs: []
            }
          },
          {
            btnName: null,
            iconFile: null,
            labelText: null,
            btnActionType: '',
            btnActionParameter: {
              screenCode: null,
              webUrl: null,
              localFile: null,
              dropBoxFile: {
                serviceDropboxUuid: null,
                fileType: '',
              },
              launchSpApp: null,
              dataUri: null,
              extraData: [
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
                { k: null, value: null, dataType: null },
              ],
              mimeType: null,
              action: null,
            },
            badgeUseFlg: 0,
            badgeDisplayCondition: 0,
            badgeDisplayParameter: {
              deliveryTypes: [],
              serviceRssUUIDs: []
            }
          }
        ]
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,

      // model
      serviceRssModel: state => state.serviceContentsSettingForm.serviceRssModel,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
    }),

    buttonCountList() {
      return (Array(5)).fill(0)
        .map((n, index) => {
          return {
            label: index,
            value: index,
          }
        });
    },

    // list
    buttonActionList () {
      return Constants.ServiceContents.ButtonAction
    },
    fileTypeList () {
      return Constants.File.ContentType
    },
    buttonBadgeUseList () {
      return Constants.ServiceContents.ButtonBadgeUse.sort(Utility.sortByKey('index', true))
    },
    buttonBadgeDIsplayConditionList () {
      return Constants.ServiceContents.ButtonBadgeDIsplayCondition
    },

    // 基本設定のサービスタイプ選択を返す
    serviceTypeCd () {
      return this.$parent.$refs.basicSetting.input.serviceTypeCd
    },
    showScreenSelectorButton () {
      console.log('Validator.validSelect(this.serviceTypeCd)', Validator.validSelect(this.serviceTypeCd))
      return Validator.validSelect(this.serviceTypeCd) && this.inited
    },

    // enable
    disableFileSelector1 () {
      return this.inpFileType1 === ''
    },
    disableFileSelector2 () {
      return this.inpFileType2 === ''
    },
    disableFileSelector3 () {
      return this.inpFileType3 === ''
    },
    disableFileSelector4 () {
      return this.inpFileType4 === ''
    },

    // validate
    formIsValid () {
      // ボタン1
      if (this.buttonCount > 0) {
        const v1 = this.validate('btnSettings.0.btnName') &&
          this.validate('btnSettings.0.iconFile') &&
          this.validate('btnSettings.0.labelText') &&
          this.validate('btnSettings.0.btnActionType') &&
          this.validate('btnSettings.0.badgeDisplayCondition')
        if (!v1) return false

        // ボタン1 : 選択時動作
        let v2 = false
        switch (this.input.btnSettings[0].btnActionType) {
          case 0: // 画面遷移
            v2 = this.validate('btnSettings.0.btnActionParameter.screenCode')
            break
          case 1: // サイト表示
            v2 = this.validate('btnSettings.0.btnActionParameter.webUrl')
            break
          case 2: // ローカルファイル表示
            v2 = this.validate('btnSettings.0.btnActionParameter.localFile')
            break
          case 3: // DropBox連携
            v2 = this.validate('btnSettings.0.btnActionParameter.dropBoxFile.serviceDropboxUuid') &&
              this.validate('btnSettings.0.btnActionParameter.dropBoxFile.fileType')
            break
          case 4: // アプリ起動
            v2 = this.validate('btnSettings.0.btnActionParameter.launchSpApp') ||
              this.validate('btnSettings.0.btnActionParameter.action')
            break
          case 5: // 一つ前の画面へ戻る
            v2 = true
            break
        }
        if (!v2) return false

        // ボタン1 : 表示条件
        if (this.input.btnSettings[0].badgeUseFlg === 1) {
          let v3 = false
          switch (this.input.btnSettings[0].badgeDisplayCondition) {
            case 0: // 既読処理
              v3 = this.validate('btnSettings.0.badgeDisplayParameter.deliveryTypes')
              break
            case 1: // 新着処理
              v3 = this.validate('btnSettings.0.badgeDisplayParameter.serviceRssUUIDs')
              break
          }
          if (!v3) return false
        }
      }

      // ボタン2
      if (this.buttonCount > 1) {
        const v4 = this.validate('btnSettings.1.btnName') &&
          this.validate('btnSettings.1.iconFile') &&
          this.validate('btnSettings.1.labelText') &&
          this.validate('btnSettings.1.btnActionType') &&
          this.validate('btnSettings.1.badgeDisplayCondition')
        if (!v4) return false

        // ボタン2 : 選択時動作
        let v5 = false
        switch (this.input.btnSettings[1].btnActionType) {
          case 0: // 画面遷移
            v5 = this.validate('btnSettings.1.btnActionParameter.screenCode')
            break
          case 1: // サイト表示
            v5 = this.validate('btnSettings.1.btnActionParameter.webUrl')
            break
          case 2: // ローカルファイル表示
            v5 = this.validate('btnSettings.1.btnActionParameter.localFile')
            break
          case 3: // DropBox連携
            v5 = this.validate('btnSettings.1.btnActionParameter.dropBoxFile.serviceDropboxUuid') &&
              this.validate('btnSettings.1.btnActionParameter.dropBoxFile.fileType')
            break
          case 4: // アプリ起動
            v5 = this.validate('btnSettings.1.btnActionParameter.launchSpApp') ||
              this.validate('btnSettings.1.btnActionParameter.action')
            break
          case 5: // 一つ前の画面へ戻る
            v5 = true
            break
        }
        if (!v5) return false

        // ボタン2 : 表示条件
        if (this.input.btnSettings[1].badgeUseFlg === 1) {
          let v6 = false
          switch (this.input.btnSettings[1].badgeDisplayCondition) {
            case 0: // 既読処理
              v6 = this.validate('btnSettings.1.badgeDisplayParameter.deliveryTypes')
              break
            case 1: // 新着処理
              v6 = this.validate('btnSettings.1.badgeDisplayParameter.serviceRssUUIDs')
              break
          }
          if (!v6) return false
        }
      }

      return true
    },

    // jsonb
    getJsonb () {
      let jsonb = {
        btnSettings: []
      }

      // ロゴ画像
      if (Validator.validFile(this.input.logoFile)) {
        jsonb.logoFile = this.input.logoFile
      }

      // ヘッダパネルカラー
      if (Validator.validText(this.input.panelColor)) {
        jsonb.panelColor = this.input.panelColor
      }

      // ヘッダパネル透過
      jsonb.panelTransparency = this.input.panelTransparency

      // ボタン設定
      const data = this.input.btnSettings
      // const l = data.length
      const l = this.buttonCount
      for (let i = 0; i < l; i++) {
        jsonb.btnSettings.push({
          btnName: data[i].btnName,
          iconFile: data[i].iconFile,
          labelText: data[i].labelText,
          btnActionType: data[i].btnActionType,
          badgeUseFlg: data[i].badgeUseFlg,
          badgeDisplayCondition: data[i].badgeDisplayCondition,
        })

        // 選択時動作
        switch (jsonb.btnSettings[i].btnActionType) {
          case 0: // 画面遷移
            jsonb.btnSettings[i].btnActionParameter = {
              screenCode: data[i].btnActionParameter.screenCode
            }
            break
          case 1: // サイト表示
            jsonb.btnSettings[i].btnActionParameter = {
              webUrl: data[i].btnActionParameter.webUrl
            }
            break
          case 2: // ローカルファイル表示
            jsonb.btnSettings[i].btnActionParameter = {
              localFile: data[i].btnActionParameter.localFile
            }
            break
          case 3: // DropBox連携
            jsonb.btnSettings[i].btnActionParameter = {
              dropBoxFile: data[i].btnActionParameter.dropBoxFile
            }
            break
          case 4: // アプリ起動
            // jsonb.btnSettings[i].btnActionParameter = {
            //   launchSpApp: data[i].btnActionParameter.launchSpApp
            // }
            jsonb.btnSettings[i].btnActionParameter = {}
            if (data[i].btnActionParameter.launchSpApp) {
              jsonb.btnSettings[i].btnActionParameter.launchSpApp = data[i].btnActionParameter.launchSpApp
            }
            if (data[i].btnActionParameter.dataUri) {
              jsonb.btnSettings[i].btnActionParameter.dataUri = data[i].btnActionParameter.dataUri
            }
            if (data[i].btnActionParameter.mimeType) {
              jsonb.btnSettings[i].btnActionParameter.mimeType = data[i].btnActionParameter.mimeType
            }
            if (data[i].btnActionParameter.action) {
              jsonb.btnSettings[i].btnActionParameter.action = data[i].btnActionParameter.action
            }
            var extraData = data[i].btnActionParameter.extraData
              .filter(item => Validator.validText(item.k) &&
                Validator.validText(item.value) &&
                Validator.validText(item.dataType))
              .map(item => {
                // var v = item.dataType === 'integer'
                //   ? Number(item.value)
                //   : item.dataType === 'boolean'
                //     ? Boolean(item.value)
                //     : item.value
                return {
                  key: item.k,
                  value: item.value,
                  dataType: item.dataType,
                }
              })
            if (extraData.length) {
              jsonb.btnSettings[i].btnActionParameter.extraData = extraData
            }
            break
          case 5: // 一つ前の画面へ戻る
            // jsonb.btnSettings[i].btnActionParameter = {
            //   screenCode: null
            // }
            break
        }

        // 表示条件
        if (jsonb.btnSettings[i].badgeUseFlg === 1) {
          switch (jsonb.btnSettings[i].badgeDisplayCondition) {
            case 0: // 既読処理
              jsonb.btnSettings[i].badgeDisplayParameter = {
                deliveryTypes: data[i].badgeDisplayParameter.deliveryTypes
              }
              break
            case 1: // 新着処理
              jsonb.btnSettings[i].badgeDisplayParameter = {
                serviceRssUUIDs: data[i].badgeDisplayParameter.serviceRssUUIDs
              }
              break
          }
        }
      }

      return jsonb
    },
  },
  watch: {
    // 基本設定のサービスタイプが変更されたら画面選択をクリア
    serviceTypeCd: function (to, from) {
      if (from === '') return
      this.input.btnSettings[0].btnActionParameter.screenCode = null
      this.input.btnSettings[1].btnActionParameter.screenCode = null
      this.input.btnSettings[2].btnActionParameter.screenCode = null
      this.input.btnSettings[3].btnActionParameter.screenCode = null
    },
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        // console.log(this.getJsonb)
        this.setValidate({
          key: 'contentsHeader',
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      setValidate: 'serviceContentsSettingForm/setValidate'
    }),

    init () {
      if (this.values.contentsHeader) {
        let data = $.extend(true, this.input, this.values.contentsHeader)
        data.btnSettings.map(item => {
          item.btnActionParameter.extraData = item.btnActionParameter.extraData
            .map(item => {
              return {
                k: item.key,
                value: item.value,
                dataType: item.dataType,
              }
            })
          return item
        })

        // バッジ設定で設定済のRSS設定が削除されていた場合、入力値から削除する
        // console.log('@@data', data);
        // console.log('@@serviceRssModel', this.serviceRssModel)
        data.btnSettings.map(item => {
          let fixedRssList = item.badgeDisplayParameter.serviceRssUUIDs
            .filter(uuid => this.serviceRssModel.findIndex(item => item.serviceRssUuid === uuid) !== -1)
          // console.log('@@fixedRssList', fixedRssList)
          item.badgeDisplayParameter.serviceRssUUIDs = fixedRssList
          return item
        })

        this.$set(this, 'input', data)

        this.buttonCount = this.values.contentsHeader.btnSettings
          ? this.values.contentsHeader.btnSettings.length
          : 0;
      }

      this.setValidate({
        key: 'contentsHeader',
        value: this.formIsValid
      })

      this.inited = true
    },

    /**
     * ファイル
     */
    getInputNode (name) {
      let nodes = name.split('.')
      let origin = this.input
      let key
      nodes.forEach((item, index) => {
        if (index < nodes.length - 1) {
          origin = origin[item]
        } else {
          key = item
        }
      })
      return {
        parent: origin,
        key: key
      }
    },
    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', data.parent[data.key])
    },
    changeExtraDataSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data)
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
      console.log('deleteFileFromSelector', null)
    },

    /**
     * Dropbox設定の変更
     */
    changeDropboxValue (props) {
      console.log('changeDropboxValue', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.value)
    },

    /**
     * 画面の変更
     */
    changeScreenFromSelector (props) {
      console.log('changeScreenFromSelector', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data.screenCode)
    },
    /**
     * 画面の削除
     */
    deleteScreenFromSelector (props) {
      console.log('deleteScreenFromSelector', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
    },

    /**
     * DeliveryType設定の変更
     */
    changeDeliveryTypeValue (props) {
      console.log('changeDeliveryTypeValue', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data)
    },

    /**
     * Rss設定の変更
     */
    changeRssValue (props) {
      console.log('changeRssValue', props)
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, props.data)
    },

    validate (key) {
      let data = this.getInputNode(key)
      let value = data.parent[data.key]
      switch (key) {
        case 'btnSettings.0.btnActionType':
        case 'btnSettings.0.badgeDisplayCondition':
        case 'btnSettings.0.btnActionParameter.screenCode':
        case 'btnSettings.0.btnActionParameter.dropBoxFile.serviceDropboxUuid':
        case 'btnSettings.0.btnActionParameter.dropBoxFile.fileType':
        case 'btnSettings.1.btnActionType':
        case 'btnSettings.1.badgeDisplayCondition':
        case 'btnSettings.1.btnActionParameter.screenCode':
        case 'btnSettings.1.btnActionParameter.dropBoxFile.serviceDropboxUuid':
        case 'btnSettings.1.btnActionParameter.dropBoxFile.fileType':
        case 'btnSettings.2.btnActionType':
        case 'btnSettings.2.badgeDisplayCondition':
        case 'btnSettings.2.btnActionParameter.screenCode':
        case 'btnSettings.2.btnActionParameter.dropBoxFile.serviceDropboxUuid':
        case 'btnSettings.2.btnActionParameter.dropBoxFile.fileType':
        case 'btnSettings.3.btnActionType':
        case 'btnSettings.3.badgeDisplayCondition':
        case 'btnSettings.3.btnActionParameter.screenCode':
        case 'btnSettings.3.btnActionParameter.dropBoxFile.serviceDropboxUuid':
        case 'btnSettings.3.btnActionParameter.dropBoxFile.fileType':
          return Validator.validSelect(value)
        case 'btnSettings.0.btnName':
        case 'btnSettings.0.labelText':
        case 'btnSettings.0.btnActionParameter.webUrl':
        case 'btnSettings.0.btnActionParameter.launchSpApp':
        case 'btnSettings.0.btnActionParameter.action':
        case 'btnSettings.1.btnName':
        case 'btnSettings.1.labelText':
        case 'btnSettings.1.btnActionParameter.webUrl':
        case 'btnSettings.1.btnActionParameter.launchSpApp':
        case 'btnSettings.1.btnActionParameter.action':
        case 'btnSettings.2.btnName':
        case 'btnSettings.2.labelText':
        case 'btnSettings.2.btnActionParameter.webUrl':
        case 'btnSettings.2.btnActionParameter.launchSpApp':
        case 'btnSettings.2.btnActionParameter.action':
        case 'btnSettings.3.btnName':
        case 'btnSettings.3.labelText':
        case 'btnSettings.3.btnActionParameter.webUrl':
        case 'btnSettings.3.btnActionParameter.launchSpApp':
        case 'btnSettings.3.btnActionParameter.action':
          return Validator.validText(value)
        case 'btnSettings.0.iconFile':
        case 'btnSettings.0.btnActionParameter.localFile':
        case 'btnSettings.1.iconFile':
        case 'btnSettings.1.btnActionParameter.localFile':
        case 'btnSettings.2.iconFile':
        case 'btnSettings.2.btnActionParameter.localFile':
        case 'btnSettings.3.iconFile':
        case 'btnSettings.3.btnActionParameter.localFile':
          return Validator.validFile(value)
        case 'btnSettings.0.badgeDisplayParameter.deliveryTypes':
        case 'btnSettings.0.badgeDisplayParameter.serviceRssUUIDs':
        case 'btnSettings.1.badgeDisplayParameter.deliveryTypes':
        case 'btnSettings.1.badgeDisplayParameter.serviceRssUUIDs':
        case 'btnSettings.2.badgeDisplayParameter.deliveryTypes':
        case 'btnSettings.2.badgeDisplayParameter.serviceRssUUIDs':
        case 'btnSettings.3.badgeDisplayParameter.deliveryTypes':
        case 'btnSettings.3.badgeDisplayParameter.serviceRssUUIDs':
          return Validator.validArray(value)
      }
    },
  }
}
